import useBlockPotTokenData from '@/hooks/contracts/block-pot-token/useBlockPotTokenData'
import { useBptDialogOpen } from '@/providers/ModalOpenStateProvider'
import Binding from '@/utilities/binding'
import { formatFixedMaxDecimalsGreedy } from '@/utilities/formatters'
import { Button } from '@blockpot-dev/block-pot-design-system'
import { ChevronRight } from 'lucide-react'
import Image from 'next/image'
import { useMemo } from 'react'

export type PureBPTWalletItemProps = {
    bptBalanceFormatted: string
    bptDialogOpen: Binding<boolean>
}

export function PureBPTWalletItem(props: PureBPTWalletItemProps) {
    const { bptBalanceFormatted, bptDialogOpen } = props

    return (
        <Button variant='outline' size='sm' className='h-[40px] flex items-center gap-2 justify-center rounded-sm bg-gray-950 pl-3 pr-1 cursor-pointer' onClick={() => bptDialogOpen.update(true)}>
            <Image src='/assets/svgs/logo-round.svg' alt='BPT' width={24} height={24} />
            <span>
                <span className='text-foreground font-bold'>
                    {bptBalanceFormatted}
                </span>
                <span className='text-secondary-foreground'>
                    {' BPT'}
                </span>
            </span>
            <ChevronRight size={24}/>
        </Button>
    )
}

export default function BPTWalletItem() {
    const bptData = useBlockPotTokenData()
    const bptDialogOpen = useBptDialogOpen()
    const bptBalanceFormatted = useMemo(() => {
        return formatFixedMaxDecimalsGreedy(bptData.balance, 18, 0)
    }, [bptData.balance])

    return (
        <PureBPTWalletItem
            bptBalanceFormatted={bptBalanceFormatted}
            bptDialogOpen={bptDialogOpen}
        />
    )
}